import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { CONTENT } from "@/content";

export default function FinalMessage({ onCelebrate }) {
  const { script, title, body, signature } = CONTENT.finalMessage;
  return (
    <section
      className="px-6 md:px-16 py-32 md:py-48 relative overflow-hidden text-center"
      data-testid="final-message-section"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(50% 50% at 50% 40%, rgba(232,180,184,0.10), transparent 70%)",
        }}
      />
      <div className="relative max-w-3xl mx-auto">
        <motion.p
          className="font-script text-3xl md:text-4xl mb-6"
          style={{ color: "var(--rose)" }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          {script}
        </motion.p>

        <motion.h2
          className="font-serif-d tracking-tightest text-5xl md:text-7xl font-light mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
        >
          {title}
        </motion.h2>

        <div className="space-y-6 mb-14">
          {body.map((p, i) => (
            <motion.p
              key={i}
              className="font-body text-base md:text-lg leading-relaxed"
              style={{ color: "var(--muted-rose)" }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.15 }}
            >
              {p}
            </motion.p>
          ))}
        </div>

        <motion.button
          onClick={onCelebrate}
          data-testid="celebrate-again-button"
          className="inline-flex items-center gap-3 rounded-full px-9 py-4 font-body text-sm uppercase tracking-[0.25em]"
          style={{ border: "1px solid var(--rose)", color: "var(--rose)" }}
          whileHover={{ scale: 1.05, backgroundColor: "rgba(232,180,184,0.08)" }}
          whileTap={{ scale: 0.97 }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          <Sparkles size={16} />
          celebrate again
        </motion.button>

        <motion.p
          className="font-script text-2xl md:text-3xl mt-16"
          style={{ color: "var(--alabaster)" }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          {signature}
        </motion.p>
      </div>
    </section>
  );
}
